import React, {useState, useRef} from 'react'
import logo from "./logo.png"
import "./login_page.css"
import Cookies from 'js-cookie'
import { useNavigate} from 'react-router-dom';


function Login_page() {
    const [inputusername, setusername] = useState('');


    const handleusernameChange = (event) => {
        // Update the state with the new input value
        setusername(event.target.value);
    };
    const [pwd_error, set_pwd_error] = useState(null)


    const [password, setpassword] = useState('');

    const handlepasswordChange = (event) => {
        // Update the state with the new input value
        setpassword(event.target.value);
    };
    const handleClick = () => {
        handle_login(inputusername, password)
    }
    let navigate = useNavigate();
    const routeChange = () =>{
        let path = `/calendar`;
        navigate(path);
    }
    const handle_login = (username, password) => {
        set_pwd_error(null)
        const path = '/api/login';
        fetch(path , {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({username: username.trimEnd(), password: password})
        }).then((res) => res.json())
            .then((data) => {
                console.log(data)
                if(data.token !== null) {
                    let currentUrl = window.location.href;
                    if(currentUrl.match("localhost"))
                        currentUrl = "localhost"
                    else currentUrl = currentUrl.match(/\/\/(.*?)(\/|:)/)[1];
                    Cookies.set('token', data.token, { domain: currentUrl,  expires: data.expires_in/ 86400, sameSite: 'Lax', secure: false})
                    //console.log(Cookies.set('token', data.token, {  path: '/', domain: 'http://10.0.6.80',  expires: data.expires_in/ 86400, sameSite: 'strict', secure: true}))
                    Cookies.set('admin', data.admin,{ expires: data.expires_in/ 86400, sameSite: 'Lax', secure: false, domain: currentUrl});
                    routeChange()
                }else{
                    set_pwd_error(data.error)
                }

                //setData(data);
                //setIsLoading(false); // Setzt isLoading auf false, wenn die Daten geladen wurden
            });
    }

    const inputRef = useRef(null);
    const handleKeyPress = (event) => {
        // Check if the pressed key is Enter (key code 13)
        if (event.key === 'Enter') {
            // Prevent the default behavior of the Enter key (e.g., form submission)
            event.preventDefault();

            // Programmatically click the button
            if (inputRef.current) {
                inputRef.current.click();
            }
        }
    };


    return (
        <div className={"page"}>
            <center>
                <img src={logo} alt='text' className='logo'></img>
                <h1>Dispo</h1>
                <table className='login_input'>
                    <tbody>
                    {pwd_error ? <tr>
                        <th>
                            <p style={{fontSize:"20px", color:"red", textAlign:"center"}}>{pwd_error}</p>
                        </th>
                    </tr>: null}
                    <tr>
                        <th>
                            <label>Username </label>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            <input name="username" className='login_input' value={inputusername}
                                   onChange={handleusernameChange}></input>
                        </th>


                    </tr>
                    <tr>
                        <th>
                            <label>Passwort </label>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            <input type="password" name="passwort" className='login_input' value={password}
                                   onChange={handlepasswordChange} onKeyDown={handleKeyPress}></input>
                        </th>

                    </tr>
                    </tbody>
                </table>
                <button className='button-6' onClick={handleClick} ref={inputRef}>Anmelden</button>
            </center>
        </div>

    );


}





export default Login_page;